import React from 'react'

const HomeBloodTestResults = () => {
  return (
    <div id='website-responsive' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/ULC-Testing-bg-v1.png")', height:'100%', width:'100%'}}>
        <div className='left-padding6rem right-padding6rem p-top-bottom2rem bg-img'>
            <div className=''>
                <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700'>
                    ACCURATE BLOOD TESTS RESULTS & AFFORDABLE CARE
                </text>
                <hr className='hr-style' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>
            <div className='py-2'>
                <text className='fs-ss-18-3 fw-600 text-montserrat text-ss-black' style={{ fontStyle:'italic'}} >
                    We can deliver results for blood work in the same day, less than 5 hours.
                </text>
            </div>

            <div className='py-4'>
                <text className='fs-ss-16 text-ss-black fw-600 text-montserrat' style={{ letterSpacing:'0.5px'}}>
                    At United Lab Care (ULC), we make blood testing easy and affordable for everyone. We understand the importance of regular blood tests in monitoring your health and detecting potential health issues early on. That’s why we have streamlined the process to provide a convenient and accessible experience for our clients.
                </text>
            </div>

            <div className='pt-md-2'>
                <text className='fs-ss-16 text-ss-black fw-600 text-montserrat' style={{ letterSpacing:'0.5px'}}>
                    Regarding blood testing, United Lab Care is your go-to partner for easy and affordable solutions. Take charge of your health with our user-friendly services and discover a healthier and happier you. Visit our conveniently located labs and experience the convenience and affordability of blood testing at ULC. Your well-being is our priority!
                </text>
            </div>
        </div>
    </div>
  )
}

export default HomeBloodTestResults